export default function () {
  const initialState = {}

  return (state = initialState, action) => {
    switch (action.type) {
      default:
        return state
    }
  }
}
